// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4o-1";
export var standaloneTable = "_4o-0";